import React from 'react';

// A single row in a DNS records table.
// Show the TTL cell iff show_ttl.
/*
 * A table of DNS records, complete with headers and hints.
 *
 * @param {string} props.domain - The domain to provide help for.
 * @param {array}  props.type - The type of the DNS record.
 * @param {bool}   props.show_ttl - true iff you want to display the ttl column.
 * @param {bool}   props.value - The value of the DNS record, e.g. a target name for a CNAME or an IP for an A record.
 */
class DnsRecord extends React.Component {
  render() {
    let ttl = this.props.show_ttl ? <div className="dns-ttl">{this.props.ttl}</div> : <div></div>;
    let hint_items = [];
    if (this.props.hints) {
      for (var j = 0; j < this.props.hints.length; j++) {
        hint_items.push(<li key={j}>{this.props.hints[j]}</li>);
      }
    }

    return (
      <div className="dns-records-row">
        <div className="dns-records-entry">
          <div className="dns-domain">{this.props.domain}</div>
          <div className="dns-type">IN {this.props.type}</div>
          {ttl}
          <div className="dns-value">{this.props.value}</div>
          <div style={{display: 'block', clear: 'both', float: 'none'}}></div>
        </div>
        <div className="dns-record-hints" style={{display: 'block', clear: 'both'}}>
          <ul>{hint_items}</ul>
        </div>
      </div>
    );
  }
}

module.exports = DnsRecord;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/host_helper/dns_record.jsx